import React from 'react';
import styles from '../command-palette.scss';
import { SearchIcon } from '@qualtrics/ui-react/icons';
import PropTypes from 'prop-types';

export const CommandPaletteTrigger = ({ setOpen }) => {
  return (
    <button
      className={styles.commandPaletteTrigger}
      onClick={() => setOpen(true)}
      type="button"
    >
      <SearchIcon className={styles.triggerIcon} aria-hidden />
      <span className={styles.triggerText}>Search Qualtrics</span>
      <div className={styles.triggerShortcut}>
        <span className={styles.triggerKey}>⌘</span>
        <span className={styles.triggerKey}>K</span>
      </div>
    </button>
  );
};

CommandPaletteTrigger.propTypes = {
  setOpen: PropTypes.func.isRequired,
};
